import { storageService } from '../storage';
import { useAuthenticationServiceAdapter } from './authenticationService';

export const authenticationService =
  useAuthenticationServiceAdapter(storageService);
